import { useLayoutEffect, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { Check } from 'lucide-react'
import { DURATION, EASE_OUT, prefersReducedMotion } from './goalMotion'

// The toast that marks a met week. It rides the app's toaster (bottom right) but draws its own card,
// because a custom toast skips the app's toast surface. No Undo: a week is met by work that already
// happened, and taking it back means undoing that task or entry where it lives.

const WeekMetContent = ({ title, detail, visible }: { title: string; detail: string; visible: boolean }) => {
    const ref = useRef<HTMLDivElement>(null)
    useLayoutEffect(() => {
        if (!ref.current || prefersReducedMotion()) return
        ref.current.animate(
            [
                { opacity: 0, transform: 'translateY(12px) scale(0.96)' },
                { opacity: 1, transform: 'translateY(0) scale(1)' },
            ],
            { duration: DURATION.slow, easing: EASE_OUT }
        )
    }, [])
    return (
        <div
            ref={ref}
            role="status"
            style={{ transition: `opacity ${DURATION.fast}ms ease-in`, opacity: visible ? 1 : 0 }}
            className="box-border flex items-center gap-3 rounded-gt-md border border-border bg-background py-2.5 pl-3 pr-4 font-sans shadow-gt-l"
        >
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-success text-white">
                <Check size={16} strokeWidth={2.5} aria-hidden />
            </span>
            <span className="flex min-w-0 flex-col">
                <span className="text-title-sm text-foreground">{title}</span>
                <span className="text-body-sm text-muted-foreground">{detail}</span>
            </span>
        </div>
    )
}

export const showWeekMetToast = (goalTitle: string) =>
    toast.custom((t) => <WeekMetContent title="Week met" detail={goalTitle} visible={t.visible} />, {
        duration: 5000,
    })
